// Session persistence. "Keep me logged in" stores the session in localStorage;
// otherwise it lives in sessionStorage and ends when the browser closes.
const SESSION_KEY = 'cp.session';

const safe = (fn, fallback = null) => {
  try {
    return fn();
  } catch (e) {
    return fallback;
  }
};

export const storageService = {
  getSession() {
    const raw = safe(() => localStorage.getItem(SESSION_KEY)) || safe(() => sessionStorage.getItem(SESSION_KEY));
    return raw ? safe(() => JSON.parse(raw)) : null;
  },
  setSession(session, remember = false) {
    this.clearSession();
    const store = remember ? localStorage : sessionStorage;
    safe(() => store.setItem(SESSION_KEY, JSON.stringify(session)));
  },
  updateSession(patch) {
    const current = this.getSession();
    if (!current) return;
    const remember = safe(() => !!localStorage.getItem(SESSION_KEY), false);
    this.setSession({ ...current, ...patch }, remember);
  },
  clearSession() {
    safe(() => localStorage.removeItem(SESSION_KEY));
    safe(() => sessionStorage.removeItem(SESSION_KEY));
  },
  getToken() {
    return this.getSession()?.token || null;
  },
  get(key, fallback = null) {
    const raw = safe(() => localStorage.getItem(key));
    return raw ? safe(() => JSON.parse(raw), fallback) : fallback;
  },
  set(key, value) {
    safe(() => localStorage.setItem(key, JSON.stringify(value)));
  },
  remove(key) {
    safe(() => localStorage.removeItem(key));
  },
};

export default storageService;
